import classNames from 'classnames';
import isString from 'lodash-es/isString';
import { ChangeEvent, CSSProperties, useEffect, useRef } from 'react';

import styles from '../../styles/fields/select-field.module.css';

interface SelectFieldProps {
    name?: string | null;
    options?: (FieldOption | string)[] | null;
    value?: string | null;
    errors?: string[] | null;
    withBorder?: boolean;
    className?: string | null;
    onChange?: ((value: string) => void) | null;
    style?: CSSProperties | null;
}

function SelectField({
    options = null,
    name = null,
    value = null,
    errors = null,
    withBorder = false,
    onChange = null,
    className = null,
    style = null,
}: SelectFieldProps) {
    const finalOptions = (options || []).map((it) =>
        isString(it)
            ? {
                  label: it,
                  value: it,
              }
            : it,
    );
    const internalRef = useRef<HTMLSelectElement>(null);
    const onInputChange = (e: ChangeEvent<HTMLSelectElement>) => {
        internalRef.current.setCustomValidity('');
        if (onChange !== null) {
            onChange(e.currentTarget.value);
        }
    };
    useEffect(() => {
        internalRef.current.setCustomValidity(
            errors !== null && errors.length > 0 ? errors[0] : '',
        );
        if (errors !== null && errors.length > 0) {
            internalRef.current.reportValidity();
        }
    }, [errors]);
    return (
        <select
            ref={internalRef}
            name={name}
            value={value || ''}
            onChange={onInputChange}
            className={classNames([
                styles.container,
                {
                    [styles.withBorder]: withBorder,
                },
                className,
            ])}
            style={style}
        >
            {(finalOptions || []).map(({ label, value: optionValue }) => (
                <option key={`option-${optionValue}`} value={optionValue}>
                    {label}
                </option>
            ))}
        </select>
    );
}

export default SelectField;
